import { react } from "../../../omnia"
import { LayerType, SelectionField } from "../../types"

interface Props {
    field: SelectionField
    layerTypes: LayerType[]
}

export function FieldLayerTypesPopup(props: Props) {

    return <react.Popup
        popupContent={Popup}
        align="topLeft"
        origin="bottomLeft"
        wrapper={false}
        popupContentProps={() => props}>

        <button type="button" className="btn btn-icon transparent">
            <i className="fas fa-ellipsis-h"></i>
        </button>

    </react.Popup>

}

function Popup({ field, layerTypes }: Props) {

    const set = new Set(field.layers.map(l => l.typeId))

    const types = layerTypes.filter(t => set.has(t.typeId))

    return <ul className="">
        {
            types.map(t => <li key={t.typeId}>{t.name}</li>)
        }
    </ul>
}
